import { createContext, useContext } from 'react';

export type SkillsAndToolsDialogType = {
  isDialogOpen: boolean;
  openDialog: () => void;
  closeDialog: () => void;
  isSkillsLinkingEnabled: boolean;
  setIsEnableSkillsLinking: (x0: boolean) => void;
};

const SkillsAndToolsDialogContext = createContext<SkillsAndToolsDialogType>({
  isDialogOpen: false,
  openDialog: () => {},
  closeDialog: () => {},
  isSkillsLinkingEnabled: false,
  setIsEnableSkillsLinking: () => {},
});

export const useSkillsAndToolsDialog = () => {
  const context = useContext(SkillsAndToolsDialogContext);

  return context;
};

export default SkillsAndToolsDialogContext;
